import { ModuleContainer } from '../containers/ModuleContainer';
import { SkinContainer } from '../containers/SkinContainer';

export default {
  ModuleContainer,
  SkinContainer,
};
